// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MachineLearningStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import uiState from 'logic/Izenda.UiState.js';
import { action, observable,observe } from 'mobx';
import {
    INFOCONFIGMESSAGE,
    COMPLETED,
    INPROGRESS,
    INITIALIZE,
    ERROR,
    ERRORMESSAGE,
    ACTIVE_NLQ_DISABLEMSG,
    CONNECTION_DISABLE_MSG,
    SEARCH_MODE,
    CONFIG_STATUS_CALL_TIME,
    REQUEST_MODE,
    SEARCH_MODE_TEXT
} from 'logic/data/Izenda.NLQConfigurationConstants';
import nlqfetcher from 'fetchers/Izenda.NLQFetcher';
import notificationFetcher from 'fetchers/Izenda.NotificationFetcher';
import {MESSAGES} from 'logic/data/Izenda.NotificationConstants';

export default class NLQConfiguration {
    @observable connectionList;
    @observable isConfigureDisable;
    @observable schemaKey; // connection Id
    @observable selectedConnection;
    @observable message = '';
    @observable isProressBar;
    @observable schemaStatus;
    @observable searchMode;
    @observable activeNLQInfo = null;
    @observable isSwitchDisable;
    @observable searchModemessage;
    @observable requestMode;
    @observable nlqSearchModeVisibility=false;

    setTimeOutConfigStatus;
    constructor(getAllConnectionString) {
        
        getAllConnectionString.then(connectionList => {
            this.connectionList = connectionList
                .filter(item => item.serverTypeName == 'MSSQL' || item.serverTypeName == 'PGSQL');
        });

        this.init();
        this.executeConfigureNLQStatus();
        this.getSearchModeVisibilityStatus();
    }

    init() {
        this.isConfigureDisable = true;
        this.schemaStatus = INITIALIZE;
        this.selectedConnection = {
            dbName: '',
            connectionId: ''
        };
       
        this.isProressBar = false;
        this.schemaStatus = null;
        this.searchMode = SEARCH_MODE.GUIDED;
        this.schemaStatus = INITIALIZE;
        this.activeNLQInfo = null;
        this.schemaKey = null;
        this.isSwitchDisable = true;
        this.searchModemessage = '';
        this.requestMode = REQUEST_MODE.NONE;
    }


    @action
    updateonConnectorTypeChange(selectedConnector) {
        this.updateConfigDisable(false);

        this.updateMessage('');
        if (selectedConnector.connectionId == '') {
            this.updateConfigDisable(true);
            this.selectedConnection = {
                dbName: '',
                connectionId: ''
            };
            return;
        }

        const selectedConnectorInfo = this.connectionList.filter(item => item.id == selectedConnector.connectionId);
        this.updateSelectedConnection(selectedConnector.connectionId);
        if (selectedConnectorInfo && !selectedConnectorInfo[0].visible) {
            const message = this.schemaKey == selectedConnector.connectionId ?
                ACTIVE_NLQ_DISABLEMSG : CONNECTION_DISABLE_MSG;
            this.updateMessage(message);
            this.updateConfigDisable(true);
        }
        if (this.schemaKey == selectedConnector.connectionId) {
            this.updateConfigurationSetting(this.activeNLQInfo);
        }
    }


    updateConfigurationSetting = (configStatusInfo) => {
        this.schemaKey = configStatusInfo.schemaKey;
        this.schemaStatus = configStatusInfo.status;
        this.isConfigureDisable = (this.schemaStatus == INPROGRESS || COMPLETED);
        if (this.requestMode != REQUEST_MODE.SWITCH)
            this.updateMessage(configStatusInfo.message);
        this.isProressBar = this.schemaStatus == INPROGRESS;
        const timer = setTimeout(() => {
            this.updateSelectedConnection(configStatusInfo.schemaKey);
            this.updateSearchMode(configStatusInfo.searchMode);
          }, 800);
          return () => clearTimeout(timer);
        
    };



    updateSelectedConnection = (selectedConnectionId) => {
        if(selectedConnectionId==null)
        {
            return this.selectedConnection;
        }
        let selectedConnection = {};
        const selectedConnectionInfo = this.connectionList.filter(key => {
            return key.id.toLowerCase() === selectedConnectionId.toLowerCase();
        });
        if (selectedConnectionInfo) {
            selectedConnection.dbName = selectedConnectionInfo[0].name;
            selectedConnection.connectionId = selectedConnectionInfo[0].id;
            this.selectedConnection = {
                dbName: selectedConnectionInfo[0].name,
                connectionId: selectedConnectionInfo[0].id
            };
        }
    };



    @action
    resetNLQConfiguration = (data) => {
        this.schemaKey = null;
        this.selectedConnection = {
            dbName: '',
            connectionId: ''
        };
        this.message = data.messages[0].messages[0];
        this.updateNotifyForReset(data);

    }

    @action
    saveNLQConfiguration = (data) => {
        this.updateConfigurationSetting(data);
        if (data.success) {

            this.executeConfigureNLQStatus();
            this.updateNLQConfigurationNotify(data);
        }
        if (!data.success) {
            this.searchModemessage = '';
            this.errorNLQConfiguration(data.message);
        }
    }

    @action
    errorNLQConfiguration = (error) => {
        this.message = ERRORMESSAGE;
        this.activeNLQInfo = null;
        this.schemaStatus = ERROR;
        this.isProressBar = false;
        this.isConfigureDisable = false;
        notificationFetcher
        .addNotification({ notificationMessageID: MESSAGES.CONFIGURE_NLQ_FAILED.id })
        .then(() => {
          uiState.setUpdateNotifications();
        });
    }


    updateNotifyForReset(resetNLQResult) {
        if (resetNLQResult && !resetNLQResult.success) {

            notificationFetcher
            .addNotification({ notificationMessageID: MESSAGES.RESET_NLQ_FAILED.id })
            .then(() => {
              uiState.setUpdateNotifications();
            });
            this.updateSchemaStatus(ERROR);
            return;
        } else (resetNLQResult && resetNLQResult.success);
        {
            this.init();
            notificationFetcher
            .addNotification({ notificationMessageID: MESSAGES.RESET_NLQ_SUCCESSFUL.id })
            .then(() => {
              uiState.setUpdateNotifications();
            });
        }
    }


    updateNLQConfigurationNotify(nlqStatusResult) {

        if (nlqStatusResult && nlqStatusResult.status === ERROR && nlqStatusResult.isMLCall) {

            notificationFetcher
            .addNotification({ notificationMessageID: MESSAGES.CONFIGURE_NLQ_FAILED.id })
            .then(() => {
              uiState.setUpdateNotifications();
            });

            return;
        }
        if (nlqStatusResult && nlqStatusResult.status === COMPLETED && nlqStatusResult.isMLCall) {
         
            notificationFetcher
            .addNotification({ notificationMessageID: MESSAGES.CONFIGURE_NLQ_SUCCESSFUL.id })
            .then(() => {
              uiState.setUpdateNotifications();
            });

            return;
        }
    }


    getConfigureNLQStatus() {
        return nlqfetcher.getConfigureNLQStatus(uiState.getTenantId());
    }

    executeConfigureNLQStatus() {
        
        nlqfetcher.getConfigureNLQStatus(uiState.getTenantId()).then(configStatusInfo => {
            if (configStatusInfo && configStatusInfo.schemaKey) {
                this.activeNLQInfo = configStatusInfo;
            }
            this.updateConfigurationSetting(configStatusInfo);
            if (configStatusInfo && configStatusInfo.status === INPROGRESS) {
                
                this.setTimeOutConfigStatus = setTimeout(() => {
                    this.executeConfigureNLQStatus();
                }, CONFIG_STATUS_CALL_TIME);
            }
            else if (configStatusInfo && configStatusInfo.status === COMPLETED) {
               
                /**Temperary code here */
                this.searchModemessage = configStatusInfo.searchMode == SEARCH_MODE.GUIDED ?
                    SEARCH_MODE_TEXT.GUIDED : SEARCH_MODE_TEXT.NATURAL;
                /**Temperary code here */
                this.updateNLQConfigurationNotify(configStatusInfo);
                clearTimeout(this.setTimeOutConfigStatus);
            }
            else if (configStatusInfo && configStatusInfo.status === ERROR || !configStatusInfo.success) {
                this.errorNLQConfiguration(configStatusInfo.message);
            }
        });
    }

    getSearchModeVisibilityStatus() {
        nlqfetcher.getNLQSearchModeVisibility().then((data) => {
            this.nlqSearchModeVisibility = data.naturalSearchStatus;
          });
    }

    updateMessage(value) {
        this.message = value;
    }

    updateSchemaStatus(value) {
        this.schemaStatus = value;
    }

    @action
    updateIsProressBar(value) {
        this.isProressBar = value;
        if (this.isProressBar && this.message === '') {
            this.updateMessage(INFOCONFIGMESSAGE);
            this.updateConfigDisable(this.isProressBar);
        }
    }

    @action
    updateSearchMode(value) {
        this.searchMode = value;
        this.updateIsSwitchDisable(true);

        if (this.activeNLQInfo && this.activeNLQInfo.activeNLQ
            && this.activeNLQInfo.searchMode != value
            && this.activeNLQInfo.schemaKey === this.selectedConnection.connectionId) {
            this.updateIsSwitchDisable(false);
            this.updateConfigDisable(true);
        }
    }

    updateConfigDisable(value) {
        this.isSwitchDisable = !value;
        this.isConfigureDisable = value;
    }

    updateIsSwitchDisable(value) {
        this.isSwitchDisable = value;
    }

    @action
    updateRequestMode(value) {
        this.requestMode = value;
    }

}


// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.NLQConfiguration.js